// extracted by mini-css-extract-plugin
export default {"status":"kozw","online":"X8xg","icon":"CY3e","checking":"eYxj","offline":"yLzO"};